import * as React from "react"
import PropTypes from "prop-types"
import Breadcrumbs from "components/Breadcrumbs"
import HeroBreadcrumbsLink from "components/Hero/HeroBreadcrumbsLink"
import HeroAboutWrapper from "components/HeroAbout/HeroAboutWrapper"
import HeroAboutTitle from "components/HeroAbout/HeroAboutTitle"
import HeroAboutText from "components/HeroAbout/HeroAboutText"
import HeroAboutImageWrapper from "components/HeroAbout/HeroAboutImageWrapper"
import HeroAboutContent from "components/HeroAbout/HeroAboutContent"
import HeroContainer from "components/Hero/HeroContainer"
import Image from "components/Image"
import htmlFormatting from "utils/htmlFormatting"
import Meta from "components/Meta"

const HeroAbout = ({ title, titleTag, breadcrumbs, heroText, image }) => (
  <HeroAboutWrapper colorVariant="Dark">
    <HeroContainer>
    {breadcrumbs?.length && (
            <Breadcrumbs itemsCope="" itemType="http://schema.org/BreadcrumbList">
              {breadcrumbs.map(
                (el, idx) =>
                  (breadcrumbs.length - 1 !== idx && (
                    <li itemProp="itemListElement" itemsCope="" itemType="https://schema.org/ListItem">
                      <HeroBreadcrumbsLink
                        itemProp="item"
                        isActive={breadcrumbs.length - 1 === idx}
                        to={el.link}
                        key={el.id}
                      >
                        <span itemProp="name">{el.title}</span>
                        <Meta itemProp="position" content={idx + 1} />
                      </HeroBreadcrumbsLink>
                    </li>
                  )) || (
                    <HeroBreadcrumbsLink
                      key={el.id}
                      itemsCope=""
                      itemProp="itemListElement"
                      itemType="https://schema.org/ListItem"
                      isActive={breadcrumbs.length - 1 === idx}
                    >
                      <span itemProp="name">{el.title}</span>
                      <Meta itemProp="position" content={idx + 1} />
                    </HeroBreadcrumbsLink>
                  ),
              )}
            </Breadcrumbs>
          )}
      <HeroAboutContent>
        <HeroAboutImageWrapper>
          <Image {...image} />
          <HeroAboutTitle as={titleTag}>{title}</HeroAboutTitle>
        </HeroAboutImageWrapper>
        {heroText && (
          <HeroAboutText
            colorVariant="Dark"
            dangerouslySetInnerHTML={{
              __html: htmlFormatting(heroText?.childMarkdownRemark?.html),
            }}
          />
        )}
      </HeroAboutContent>
    </HeroContainer>
  </HeroAboutWrapper>
)

HeroAbout.propTypes = {
  title: PropTypes.string.isRequired,
  titleTag: PropTypes.string.isRequired,
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.exact({
      id: PropTypes.string,
      title: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    }),
  ),
  heroText: PropTypes.object.isRequired,
  image: PropTypes.object.isRequired,
}

HeroAbout.defaultProps = {
  breadcrumbs: null,
}

export default HeroAbout
